import { ToastrService } from "../../toastr/toastr.service";
import { Injectable } from "@angular/core";

@Injectable()
export class MessageService {
    constructor(private toastr: ToastrService) {
    }

    //show succesfully saved 
    public showSuccessfullySavedMsg(): void {
        this.toastr.success("Successfully saved.");
    }

    public showErrorMsg(msg: any): void {
        if (msg) this.toastr.error(msg);
    }

    //show email sending failed
    public showEmailSendingFailedMsg(): void {
        this.toastr.error("Email sending failed.");
    }

    //show email sending failed
    public showCorrectAllValidationErrorsMsg(): void {
        this.toastr.error("Please correct all validation errors.");
    }

    //show success
    public showSuccessfullyCopiedMsg(): void {
        this.toastr.success("Successfully copied.");
    }

    //show user already delegated
    public showUserAlreadyDelegatedMsg(): void {
        this.toastr.error("User already delegated for the quarter.");
    }

    //show create compliance failed
    public createComplieanceFailedMsg(): void {
        this.toastr.error("Create compliance failed.");
    }
}